import { MiniappSdkContext } from 'components/miniapp-sdk-provider/miniapp-sdk.context';
import { useMiniappSdkClient } from 'hooks/use-miniapp-sdk.hook';
import React from 'react';
import { SDK_APP_UUID } from 'utils/constants';

interface MiniappSdkProviderProps {
  children: React.ReactNode;
}

export const MiniappSdkProvider = ({ children }: MiniappSdkProviderProps): JSX.Element => {
  const miniappSdkClient = useMiniappSdkClient(SDK_APP_UUID);

  return <MiniappSdkContext.Provider value={miniappSdkClient}>{children}</MiniappSdkContext.Provider>;
};
